'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (value, type) {
  var monthKeys = Object.keys(_I18n2.default.translations.en.i18n.dateTime.shortForm.months);
  var momentValue = _I18n2.default.moment[type](value);
  var shortMonthKey = monthKeys[momentValue.month()];
  var monthName = _I18n2.default.text('i18n.dateTime.shortForm.months.' + shortMonthKey);
  var dayNumber = momentValue.date();
  return _I18n2.default.text('i18n.dateTime.monthAndDay', { monthName: monthName, dayNumber: dayNumber });
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.245/js/utils/formatShortDate.js
// module id = 297
// module chunks = 0